import React from 'react';

import { Card, CardBody, CardTitle, Row, Col } from 'reactstrap';

const CardStatics = (props) => (
  <Col lg='4' xl='2' md='3'>
    <Card className='card-stats mb-4 mb-xl-0'>
      <CardBody>
        <Row>
          <div className='col'>
            <CardTitle
              tag='h5'
              className='text-uppercase text-muted mb-0'
              style={{ fontSize: '14px' }}
            >
              {props.name}
            </CardTitle>
            {props.value && (
              <span className='h1 font-weight-bold mb-0'>{props.value}</span>
            )}
          </div>
          <div style={{ fontSize: '16px' }}>
            <Col className='col-auto'>
              <div className={props.iconStyle}>
                <i className={props.icon} />
              </div>
            </Col>
            {props.children}
          </div>
        </Row>
      </CardBody>
    </Card>
  </Col>
);

export default CardStatics;
